"use client";

import { useToast } from "@/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { TextScramble } from "./text-scramble";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && (
                <div className="flex items-center">
                  <div className="bg-[#FF0000] w-1 h-1 rounded-full mr-1" />
                  <ToastTitle>
                    <TextScramble
                      className="font-mono uppercase"
                      characterSet=". "
                    >
                      {title.toString()}
                    </TextScramble>
                  </ToastTitle>
                </div>
              )}
              {description && (
                <ToastDescription className="text-xs">
                  <TextScramble
                    className="font-mono uppercase"
                    characterSet=". "
                  >
                    {description.toString()}
                  </TextScramble>
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
